import { ChevronDownSVG, ChevronUpSVG } from '@sbercloud/uikit-product-icons';
import { ICON_SIZE, SIZE } from '@snack-uikit/input-private';
export function getArrowIcon(_ref) {
  var size = _ref.size,
    open = _ref.open;
  return {
    ArrowIcon: open ? ChevronUpSVG : ChevronDownSVG,
    arrowIconSize: size === SIZE.S ? ICON_SIZE.Xs : ICON_SIZE.S
  };
}